const nl = {
  meta: {
    title: "Nexora Technologies — Europese partner voor AI-transformatie",
  },
  nav: {
    home: "Home",
    services: "Diensten",
    aiTransformation: "AI-transformatie",
    industries: "Sectoren",
    about: "Over ons",
    contact: "Contact",
    countries: "Landen",
    bookStrategy: "Plan een strategiegesprek",
  },
  countriesNav: {
    netherlands: "Nederland",
    germany: "Duitsland",
    switzerland: "Zwitserland",
    belgium: "België",
    "united-kingdom": "Verenigd Koninkrijk",
  },
  langSwitcher: { label: "Taal" },
  hero: {
    eyebrow: "De Europese partner voor AI-transformatie",
    title1: "Schaal sneller op.",
    title2: "Krijg toegang tot wereldklasse technologietalent.",
    subtitle:
      "Nexora Technologies helpt Europese organisaties technologische talenttekorten op te lossen via nearshore delivery en AI-transformatie.",
    bookDiscovery: "Plan een kennismaking",
    requestTalent: "Vraag technologietalent aan",
  },
  trustStats: [
    { value: "20+", label: "Jaar internationale delivery" },
    { value: "5", label: "Europese markten bediend" },
    { value: "500+", label: "Specialisten ingezet" },
    { value: "<1u", label: "Gemiddelde reactietijd" },
  ],
  whyUs: {
    eyebrow: "waarom nexora",
    title: "Technologie evolueert sneller dan organisaties kunnen werven.",
    lede:
      "Ervaren AI-engineers, cloud-architecten, SAP-consultants en cybersecurity-specialisten vinden is een van de grootste uitdagingen in heel Europa geworden.",
    body1:
      "Nexora geeft organisaties directe toegang tot zeer ervaren technologieprofessionals via een flexibel nearshore-deliverymodel met minimaal tijdsverschil — wat naadloze samenwerking met interne teams mogelijk maakt.",
    body2:
      "Al meer dan 20 jaar leveren we succesvolle outsourcing-, insourcing- en digitale-transformatieprogramma's voor internationale klanten.",
    aboutLink: "Over Nexora",
    deliverablesEyebrow: "wat wij leveren",
  },
  deliverables: [
    "AI-engineers",
    "Generative AI-specialisten",
    "Machine learning-engineers",
    "Cloud-engineers",
    "Cybersecurity-experts",
    "DevOps-engineers",
    "Data-engineers",
    "SAP-consultants",
    "Software-ontwikkelteams",
    "Technology Transformation Consulting",
  ],
  servicesSection: {
    eyebrow: "diensten",
    title: "Een enterprise-platform van capaciteiten — geleverd als één geheel.",
    lede:
      "Van AI-excellentiecentra tot toegewijde nearshore-engineering pods: onze diensten combineren om uw technologische executie te versnellen.",
  },
  services: [
    {
      slug: "ai-transformation",
      title: "AI-transformatie",
      summary:
        "Identificeer, ontwerp en operationaliseer AI-cases met meetbare bedrijfswaarde — van strategie tot uitrol.",
      bullets: ["AI-strategie & roadmap", "Generative AI-oplossingen", "AI-governance", "AI Centre of Excellence"],
    },
    {
      slug: "dedicated-teams",
      title: "Toegewijde engineering-teams",
      summary:
        "Senior nearshore engineering-pods die direct in uw delivery passen — zelfde tijdzone, Europese standaarden.",
      bullets: ["Pod-gebaseerde delivery", "Senior-geleide teams", "Transparante governance", "Flexibel schaalbaar"],
    },
    {
      slug: "cloud",
      title: "Cloud-engineering",
      summary:
        "Azure-, AWS- en GCP-architectuur, migratie en FinOps — gebouwd voor Europese compliance en veerkracht.",
      bullets: ["Landing zones", "Cloudmigratie", "Platform engineering", "FinOps"],
    },
    {
      slug: "cybersecurity",
      title: "Cybersecurity",
      summary: "Van zero-trust-architectuur tot OT-security — bescherm uw onderneming op elke laag.",
      bullets: ["Zero-trust ontwerp", "Cloud-security", "Identity & access", "OT / IoT-security"],
    },
    {
      slug: "sap",
      title: "SAP & enterprise-platformen",
      summary:
        "S/4HANA, BTP en enterprise-moderniseringsprogramma's, geleverd door gecertificeerde senior consultants.",
      bullets: ["S/4HANA-migratie", "BTP-ontwikkeling", "Integratie", "Managed services"],
    },
    {
      slug: "software-engineering",
      title: "Software engineering",
      summary:
        "Volledige product-engineering — discovery, design, build en moderniseren — met Europese kwaliteit.",
      bullets: ["Product engineering", "Platform-modernisering", "QA & DevOps", "API-platformen"],
    },
  ],
  countriesSection: {
    eyebrow: "onze markten",
    title: "Gebouwd voor Europese delivery.",
    lede:
      "Senior-geleide pods in uw tijdzone, met lokale marktinzichten in vijf kernlanden in Europa.",
    exploreLabel: "Bekijken",
  },
  aiFeature: {
    eyebrow: "ai-transformatie",
    title: "Artificiële intelligentie is geen toekomstinitiatief meer.",
    lede:
      "Het is een concurrentievoorwaarde geworden. Nexora helpt organisaties AI-oplossingen te identificeren, te ontwerpen en te implementeren die meetbare bedrijfswaarde creëren.",
    tags: ["AI-strategie", "Generative AI", "AI-governance", "AI Centre of Excellence"],
    exploreLink: "Bekijk AI-transformatiediensten",
  },
  principles: {
    eyebrow: "hoe wij werken",
    title: "Gebouwd voor Europese enterprise.",
    lede: "Ons deliverymodel is ontworpen voor transparantie, governance en senior-geleide uitkomsten.",
    items: [
      {
        title: "Senior-geleide engagementen",
        desc: "Elk programma wordt geleid door senior engineers en adviseurs — geen junior resources achter een merk.",
      },
      {
        title: "Europese standaarden",
        desc: "GDPR-native delivery, conform de EU AI Act, en een nearshore-model in dezelfde kantooruren.",
      },
      {
        title: "Resultaat boven uren",
        desc: "Wij committeren ons aan meetbare uitkomsten, niet aan urenbriefjes. Onze pods zijn end-to-end verantwoordelijk.",
      },
      {
        title: "Transparante governance",
        desc: "Open delivery-dashboards, wekelijkse stuurmomenten, volledige zichtbaarheid op snelheid en risico.",
      },
    ],
  },
  finalCta: {
    eyebrow: "volgende stap",
    heading: "Bouw uw concurrentievoordeel.",
    lede:
      "Spreek met een senior Nexora-strateeg. In één gesprek brengen we de hoogwaardigste technologie- en AI-zetten voor uw organisatie in kaart.",
    button: "Plan een strategiegesprek",
    exploreBtn: "Bekijk onze diensten",
  },
  leadForm: {
    stepLabels: ["Land", "Skills", "Teamgrootte", "Duur", "Uw gegevens"],
    country: { title: "Welk land?", lede: "Kies waar u senior technologietalent nodig heeft." },
    skills: {
      title: "Welke skills zoekt u?",
      lede: "Kies alles wat van toepassing is. U kunt specialisten combineren of een volledig team beschrijven.",
    },
    teamSize: {
      title: "Hoe groot moet het team zijn?",
      lede: "We schalen van één senior specialist tot een volledige pod.",
    },
    duration: {
      title: "Hoe lang loopt de samenwerking?",
      lede: "De meeste engagementen starten met 3 maanden en worden verlengd op basis van resultaat.",
    },
    details: {
      title: "Uw gegevens",
      lede: "We routeren uw aanvraag naar de juiste senior strateeg.",
      name: "Volledige naam",
      email: "Zakelijk e-mailadres",
      company: "Organisatie",
      message: "Wat wilt u bereiken? (optioneel)",
      namePh: "Jan van Berg",
      emailPh: "jan@bedrijf.eu",
      companyPh: "Uw organisatie",
      messagePh: "Beschrijf kort uw initiatief, tijdslijnen en eventuele beperkingen.",
    },
    back: "Terug",
    next: "Volgende",
    send: "Aanvraag versturen",
    sending: "Versturen…",
    successTitle: "Aanvraag ontvangen.",
    successLede:
      "Dank u wel. Een senior Nexora-strateeg neemt binnen één werkdag contact met u op voor een kennismakingsgesprek.",
    errorGeneric: "Er ging iets mis. Probeer het opnieuw.",
    toastSuccessTitle: "Aanvraag ontvangen",
    toastSuccessDesc: "Een Nexora-strateeg neemt binnen één werkdag contact met u op.",
    toastErrorTitle: "Versturen mislukt",
  },
  skills: {
    "ai-engineers": "AI-engineers",
    "generative-ai": "Generative AI-specialisten",
    "ml-engineers": "Machine learning-engineers",
    mlops: "MLOps-engineers",
    "data-engineers": "Data-engineers",
    "data-scientists": "Data scientists",
    "cloud-engineers": "Cloud-engineers (Azure / AWS / GCP)",
    "cloud-architects": "Cloud-architecten",
    devops: "DevOps-engineers",
    cybersecurity: "Cybersecurity-specialisten",
    sap: "SAP-consultants",
    "software-dev": "Software-ontwikkelteams",
    java: "Java-developers",
    dotnet: ".NET-developers",
    python: "Python-developers",
    fullstack: "Full stack-developers",
    "power-platform": "Microsoft Power Platform",
    salesforce: "Salesforce-consultants",
    transformation: "Technology Transformation Consulting",
  },
  teamSizes: {
    "1-3": "1 – 3 specialisten",
    "4-6": "4 – 6 specialisten",
    "7-10": "7 – 10 specialisten",
    "10-plus": "10+ specialisten",
  },
  durations: {
    "3m": "3 maanden",
    "6m": "6 maanden",
    "12m": "12 maanden",
    ongoing: "Doorlopend partnership",
  },
  contactPage: {
    eyebrow: "Plan een strategiegesprek",
    title1: "Bouw uw",
    title2: "concurrentievoordeel.",
    lede:
      "Vertel ons over de technologie- of AI-transformatie die u plant. Een senior Nexora-strateeg neemt binnen één werkdag contact op.",
    directHeading: "direct",
    addressList: "Amsterdam · Frankfurt · Zürich · Brussel · Londen",
    whatToExpectHeading: "wat u kunt verwachten",
    whatToExpectList: [
      "Reactie binnen één werkdag",
      "Kennismakingsgesprek met een senior strateeg",
      "Op maat gemaakt voorstel binnen <5 dagen",
      "Geen verplichting, volledige vertrouwelijkheid",
    ],
  },
  aboutPage: {
    eyebrow: "Over ons",
    title1: "De Europese partner",
    title2: "voor AI-transformatie.",
    lede:
      "Nexora Technologies helpt Europese organisaties technologische capaciteiten op te schalen met AI-transformatie, schaars technologietalent en toegewijde nearshore engineering-teams.",
    missionEyebrow: "onze missie",
    missionTitle: "Europese ondernemingen helpen concurreren in het tijdperk van AI.",
    missionPara1:
      "Al meer dan 20 jaar leveren wij outsourcing-, insourcing- en digitale-transformatieprogramma's voor internationale klanten. Vandaag richten wij ons op één missie: Europese organisaties laten winnen in het AI-tijdperk.",
    missionPara2:
      "Wij combineren schaars technologietalent, een governed nearshore-deliverymodel en diepe AI-expertise om onze klanten de uitvoeringssnelheid te geven die moderne concurrentie vraagt.",
    missionList: [
      "Vertrouwd door internationale enterprise in vijf Europese kernmarkten",
      "Senior-geleide pods — nooit junior resources achter een merk",
      "Resultaatgerichte engagementen met transparante governance",
      "AI-native delivery, GDPR-native by design",
    ],
  },
  servicesPage: {
    eyebrow: "Diensten",
    title1: "Een enterprise-platform",
    title2: "van technologische capaciteiten.",
    lede:
      "Zes met elkaar verbonden diensten — gecombineerd in één governed deliverymodel dat de technologische executie van Europese enterprise opschaalt.",
    talkLink: "Spreek met een adviseur",
  },
  industriesPage: {
    eyebrow: "Sectoren",
    title1: "Gebouwd voor sectoren",
    title2: "waar technologie bepaalt wie wint.",
    lede:
      "Sectorspecifieke deliveryteams die de dynamiek, regelgeving en concurrentierealiteit van uw branche begrijpen.",
    talkLink: "Neem contact op",
  },
  industries: [
    { slug: "financial-services", title: "Financiële dienstverlening", desc: "Banken, verzekeraars en kapitaalmarkten." },
    { slug: "government", title: "Overheid & publieke sector", desc: "Digitale overheidsdienstverlening en soevereine cloud." },
    { slug: "healthcare", title: "Healthcare & Life Sciences", desc: "Transformatie in klinische zorg, onderzoek en pharma." },
    { slug: "energy", title: "Energie & nutsbedrijven", desc: "Energietransitie, intelligente netten, OT-security." },
    { slug: "manufacturing", title: "Industrie", desc: "Industrie 4.0, smart factories, supply-chain AI." },
    { slug: "retail", title: "Retail & e-commerce", desc: "Omnichannel, personalisatie en demand AI." },
    { slug: "logistics", title: "Logistiek & transport", desc: "Netwerken, route-intelligentie en digital twins." },
    { slug: "telecom", title: "Telecommunicatie", desc: "Netwerkmodernisering en customer AI." },
  ],
  aiPage: {
    eyebrow: "AI-transformatie",
    title1: "Artificiële intelligentie",
    title2: "is geen toekomstinitiatief meer.",
    lede:
      "Het is een concurrentievoorwaarde geworden. Nexora Technologies helpt organisaties AI-oplossingen te identificeren, te ontwerpen en te implementeren die meetbare bedrijfswaarde creëren.",
    startBtn: "Start uw AI-readiness assessment",
    allServicesBtn: "Bekijk alle diensten",
    servicesEyebrow: "AI-diensten",
    servicesTitle: "Een volledige AI-deliverycapaciteit.",
    servicesLede:
      "Van advies en governance tot engineering en operations — Nexora levert AI als een managed, accountable capability.",
    approachEyebrow: "onze aanpak",
    approachTitle: "Van strategie naar schaal, in vier governed fases.",
    approachLede:
      "Nexora brengt AI van ambitie naar enterprise-grade uitkomsten — zonder het bekende PoC-kerkhof.",
    talkLink: "Spreek met een AI-adviseur",
    services: [
      { title: "AI-strategie", desc: "Definieer de meest waardevolle AI-initiatieven, afgestemd op uw strategie." },
      { title: "AI-readiness assessment", desc: "Evalueer data, talent, infrastructuur en governance-readiness." },
      { title: "AI-governance", desc: "Voer AI verantwoord uit met beleid, controls en EU AI Act-alignment." },
      { title: "AI Factory Advisory", desc: "Ontwerp een herhaalbaar deliverymodel dat AI schaalt van PoC naar productie." },
      { title: "Generative AI-oplossingen", desc: "Bouw copilots, agents en kennissystemen op uw enterprise-data." },
      { title: "AI-automatisering", desc: "Automatiseer complexe workflows door LLM's, RPA en procesintelligentie te combineren." },
      { title: "AI-integratie", desc: "Integreer AI in uw kernsystemen — CRM, ERP, dataplatforms en meer." },
      { title: "AI-infrastructuuradvies", desc: "Ontwerp GPU-, MLOps- en platformfundering voor AI in productie." },
      { title: "AI-training", desc: "Upskill leiders en engineers met rolgebaseerde AI-programma's." },
      { title: "AI Centre of Excellence", desc: "Bouw een CoE die AI-waarde orkestreert in de hele organisatie." },
    ],
    phases: [
      { step: "01", title: "Diagnose", desc: "AI-readiness, waardekaart en governance-basislijn." },
      { step: "02", title: "Ontwerp", desc: "Oplossingsarchitectuur, datafundering, target operating model." },
      { step: "03", title: "Lever", desc: "Bouw, integreer en operationaliseer met senior-geleide pods." },
      { step: "04", title: "Schaal", desc: "AI CoE, MLOps, modellevenscyclus en value tracking." },
    ],
  },
  notFound: {
    eyebrow: "404",
    title: "Pagina niet gevonden.",
    body: "De pagina die u zoekt bestaat niet — maar we praten graag toch met u.",
    backBtn: "Terug naar home",
  },
  country: {
    common: {
      specialistsEyebrow: "meest gevraagd",
      specialistsTitle: "Meest gevraagde specialisten",
      specialistsLede:
        "Rollen waar de vraag het aanbod overstijgt — en waar Nexora het snelst levert.",
      industriesEyebrow: "sectoren",
      industriesTitle: "Sectoren die wij bedienen",
      whyEyebrow: "waarom nexora",
      whyTitle: "Waarom teams voor Nexora kiezen",
      formEyebrow: "talent aanvragen",
      formTitle: "Bouw uw concurrentievoordeel.",
      formLede:
        "Vertel ons welke profielen u zoekt — wij reageren binnen één werkdag.",
      formCta: "Vraag technologietalent aan",
      exploreLabel: "Bekijk diensten",
      finalHeading: "Bouw uw concurrentievoordeel.",
      finalCta: "Plan een strategiegesprek",
      bullets: [
        "Senior-geleide teams · nearshore delivery",
        "Europese kwaliteit, GDPR-native",
        "Snel onboarden · flexibel schaalbaar",
      ],
    },
    netherlands: {
      eyebrow: "Nederland",
      title: "Technologietalent voor Nederland",
      lede:
        "De Nederlandse technologiemarkt groeit sneller dan het beschikbare talent. Wij helpen organisaties hun technologieteams snel op te schalen met zeer ervaren professionals in nagenoeg dezelfde tijdzone.",
      body:
        "Of u nu AI-oplossingen bouwt, naar Azure migreert, SAP moderniseert of uw cybersecurity versterkt — wij leveren de juiste specialisten precies wanneer u ze nodig heeft.",
      specialists: [
        "AI-engineers",
        "Azure cloud-engineers",
        "Cybersecurity-specialisten",
        "DevOps-engineers",
        "Data-engineers",
        "Microsoft Power Platform-specialisten",
        "SAP-consultants",
        "Java-developers",
        "Full stack-developers",
        "Data-analisten",
      ],
      industries: [
        "Financiële dienstverlening",
        "Overheid",
        "Healthcare",
        "Energie",
        "Logistiek",
        "Retail",
        "Industrie",
      ],
      whyUs: [
        "Nearshore-samenwerking",
        "Minimaal tijdsverschil",
        "Snel onboarden",
        "Toegewijde teams",
        "Flexibel schaalbaar",
        "20+ jaar internationale delivery-ervaring",
      ],
    },
    germany: {
      eyebrow: "Duitsland",
      title: "Technologiespecialisten voor de Duitse markt",
      lede:
        "Het tekort aan vakkrachten hoeft uw groei niet af te remmen. Onze nearshore-teams integreren naadloos in uw organisatie en leveren topkwaliteit.",
      body:
        "Of het nu AI, cloudmigratie, SAP-modernisering of cybersecurity is — wij leveren de juiste experts precies wanneer u ze nodig heeft.",
      specialists: [
        "SAP S/4HANA-consultants",
        "AI-engineers",
        "Cybersecurity-specialisten",
        "Cloud-architecten",
        "DevOps-engineers",
        "Embedded software-engineers",
        "Data-engineers",
        "Java-developers",
        "Platform engineers",
        "OT-securityspecialisten",
      ],
      industries: ["Automotive", "Industrie", "Finance", "Healthcare", "Energie", "Overheid"],
      whyUs: [
        "Nearshore-samenwerking",
        "Minimaal tijdsverschil",
        "Snel onboarden",
        "Toegewijde teams",
        "Flexibel schaalbaar",
        "20+ jaar internationale ervaring",
      ],
    },
    switzerland: {
      eyebrow: "Zwitserland",
      title: "Technologische excellentie voor Zwitserland",
      lede:
        "Zwitserse organisaties eisen technologische expertise van wereldklasse. Onze specialisten leveren enterprise-grade oplossingen tijdens vrijwel dezelfde kantooruren.",
      body:
        "Van private banking tot farmaceutisch R&D — wij leveren de senior technologen waar Zwitserse ondernemingen op vertrouwen.",
      specialists: [
        "AI-engineers",
        "Quant developers",
        "Cloud security-engineers",
        "Cybersecurity-specialisten",
        "Azure-architecten",
        "DevSecOps-engineers",
        "Data-engineers",
        "MLOps-engineers",
        "Software-architecten",
        "Blockchain-engineers",
      ],
      industries: ["Banking", "Verzekeren", "Life sciences", "Pharma", "Healthcare", "Industrie"],
      whyUs: [
        "Senior-geleide teams",
        "Zwitserse kwaliteit",
        "Samenwerking dezelfde dag",
        "Soevereine dataverwerking",
        "Ervaring in gereguleerde sectoren",
        "20+ jaar internationale delivery-ervaring",
      ],
    },
    belgium: {
      eyebrow: "België",
      title: "Technologietalent dat innovatie versnelt",
      lede:
        "Ervaren IT-professionals vinden is nooit moeilijker geweest. Onze nearshore-teams bieden direct capaciteit met behoud van Europese kwaliteitsnormen.",
      body:
        "Van de Europese instellingen in Brussel tot financiële dienstverlening en life sciences — Nexora levert in de meest veeleisende Belgische sectoren.",
      specialists: [
        "Azure-engineers",
        "SAP-consultants",
        "Cybersecurity-specialisten",
        "Data-engineers",
        "Java-developers",
        ".NET-developers",
        "DevOps-engineers",
        "AI-engineers",
        "Business intelligence-specialisten",
        "Cloud operations-engineers",
      ],
      industries: [
        "Europese instellingen",
        "Financiële dienstverlening",
        "Chemie",
        "Logistiek",
        "Healthcare",
        "Overheid",
      ],
      whyUs: [
        "Tweetalige samenwerking",
        "EU-compliant",
        "Senior deliveryteams",
        "Flexibel schaalbaar",
        "Focus op Brussel & Antwerpen",
        "20+ jaar internationale delivery-ervaring",
      ],
    },
    "united-kingdom": {
      eyebrow: "Verenigd Koninkrijk",
      title: "Technologietalent van wereldklasse voor Britse organisaties",
      lede:
        "Schaal sneller op met zeer ervaren technologiespecialisten. Wij leveren toegewijde engineeringteams met minimaal tijdsverschil en naadloze samenwerking.",
      body:
        "Van FinTech in Londen tot defensie- en energieprogramma's in het hele land — Nexora levert senior-geleide teams op de Britse kwaliteitsstandaard.",
      specialists: [
        "AI-engineers",
        "Cybersecurity-specialisten",
        "Cloud-engineers",
        "DevOps-engineers",
        "Data scientists",
        "Python-developers",
        "Java-developers",
        "Salesforce-consultants",
        "AWS-architecten",
        "Platform engineers",
      ],
      industries: [
        "Financiële dienstverlening",
        "FinTech",
        "Healthcare",
        "Retail",
        "Defensie",
        "Energie",
        "Telecommunicatie",
      ],
      whyUs: [
        "Samenwerking dezelfde dag",
        "Senior-geleide pods",
        "Britse kwaliteitsnormen",
        "Snel onboarden",
        "Flexibel schaalbaar",
        "20+ jaar internationale delivery-ervaring",
      ],
    },
  },
  footer: {
    tagline:
      "De Europese partner voor AI-transformatie. Wij helpen Europese organisaties technologische capaciteiten op te schalen via AI-transformatie, schaars technologietalent en toegewijde nearshore engineering-teams.",
    company: "Bedrijf",
    servicesCol: "Diensten",
    countriesCol: "Landen",
    about: "Over ons",
    whyNexora: "Waarom Nexora",
    contact: "Contact",
    aiTransformation: "AI-transformatie",
    servicesOverview: "Overzicht van diensten",
    industries: "Sectoren",
    privacy: "Privacy",
    terms: "Voorwaarden",
    cookies: "Cookies",
    copyright: "Alle rechten voorbehouden.",
    address: "Amsterdam · Frankfurt · Zürich · Brussel · Londen",
  },
  brandTagline: "De Europese partner voor AI-transformatie",
};

export default nl;
